import React, { useMemo } from 'react';
import { Popover } from '@noths/polaris-client-ribbons-design-system';
import { AnonymousAccountLinks } from "./AnonymousAccountLinks";
import { AuthenticatedAccountLinks } from "./AuthenticatedAccountLinks";
import { useSiteChromeStaticContext } from "../../../context/SiteChromeStaticContext/useSiteChromeStaticContext";
import { useUserContext } from "../../../context/UserContext/useUserContext";
var POPOVER_WIDTH = 234;
var X_OFFSET = 117;
var Y_OFFSET = 18;
var POINTER_CUSTOM_VALUE = 58;
var popOverDimensions = {
  width: POPOVER_WIDTH
};
export var AccountPopover = function AccountPopover(_ref) {
  var isOpen = _ref.isOpen,
    onClose = _ref.onClose,
    position = _ref.position;
  var _useSiteChromeStaticC = useSiteChromeStaticContext(),
    _useSiteChromeStaticC2 = _useSiteChromeStaticC.compact,
    compact = _useSiteChromeStaticC2 === void 0 ? false : _useSiteChromeStaticC2,
    useScopedStyles = _useSiteChromeStaticC.useScopedStyles;
  var _useUserContext = useUserContext(),
    membershipIsActive = _useUserContext.membershipIsActive,
    userAuthenticated = _useUserContext.userAuthenticated;
  var popOverPosition = useMemo(function () {
    return {
      left: position.x - X_OFFSET,
      top: position.y + Y_OFFSET
    };
  }, [position.x, position.y]);
  return /*#__PURE__*/React.createElement("div", {
    "data-testid": "account-popover"
  }, /*#__PURE__*/React.createElement(Popover, {
    bodyOpenClassName: "",
    contentLabel: "Account popover",
    dimensions: popOverDimensions,
    isOpen: isOpen,
    onRequestClose: onClose,
    pointerAlignment: "center",
    pointerCustomValue: POINTER_CUSTOM_VALUE,
    position: popOverPosition,
    shouldReturnFocusAfterClose: false,
    useScopedStyles: useScopedStyles
  }, userAuthenticated ? /*#__PURE__*/React.createElement(AuthenticatedAccountLinks, {
    includeFavourites: compact,
    member: !!membershipIsActive
  }) : /*#__PURE__*/React.createElement(AnonymousAccountLinks, {
    includeFavourites: compact
  })));
};